import FullLoader from "components/loaders/FullLoader";
import firebase from "config/firebase";
import {signOut} from "firebase/auth";
import {FC, useEffect} from "react";

const ALLOWED_HOSTS = ["akadian.booksmatch.us", "akadian-dev.booksmatch.us", "localhost"];

const LogoutPage: FC = () => {
  useEffect(() => {
    const redirect = new URLSearchParams(window.location.search).get("redirect");
    signOut(firebase.auth).finally(() => {
      if (redirect) {
        try {
          const url = new URL(redirect);
          if (ALLOWED_HOSTS.includes(url.hostname)) {
            window.location.href = redirect;
            return;
          }
        } catch {}
      }
      window.location.href = "/auth";
    });
  }, []);

  return <FullLoader />;
};

export default LogoutPage;
